// api.js
import axios from 'axios';
import { API_BASE_URL } from 'src/apiConfig';

export const getSchoolInfo = async (id) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/api/schools.php?id=${id}`
    );
    return response.data;
  } catch (error) {
    console.error(
      'Greška prilikom preuzimanja informacija o školi:',
      error.message
    );
    throw error;
  }
};
